import _isEmpty from 'lodash/isEmpty';
import NotificationsApi from '@Data/notifications/Api';
import {
    INotification,
    NotificationSeverity,
    NotificationType,
} from '@Data/notifications/Interfaces';
import { notificationsState } from '@Data/notifications/Reducer';
import { TaskType } from '@Data/processes/TaskType';
import store from '@Services/redux/Store';

export function canSubmitPayloadForm(payloadData: object): boolean {
    if (_isEmpty(payloadData)) return false;

    let canSubmit = true;

    for (const prop in payloadData) {
        if (Object.prototype.hasOwnProperty.call(payloadData, prop)) {
            const attr = payloadData[prop];
            if (!attr || attr === '') {
                canSubmit = false;
            }
            if (Array.isArray(attr)) {
                attr.forEach((value) => {
                    if (value == '' || !value) {
                        canSubmit = false;
                    }
                });
            }
        }
    }
    return canSubmit;
}

export function tryCreateProcessNotificationForTask(
    processName: string,
    taskId: string,
    taskType?: TaskType
) {
    const state = store.getState();
    const notifications: Array<INotification> = notificationsState(state);
    const existingProcessNotifications = notifications.filter(
        (n) => n.type === NotificationType.PROGRESS
    );

    const title =
        taskType === TaskType.SYNC
            ? `Syncing ${processName}`
            : `${processName} progress`;

    if (existingProcessNotifications.findIndex((n) => n.id === taskId) === -1) {
        NotificationsApi.addNotification(
            title,
            NotificationSeverity.INFO,
            NotificationType.PROGRESS,
            taskId
        );
    }
}
